/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import AdvancedHero from '../../components/heros/advanced';
import Footer from '../../components/footer';
// Images
import Join from '../../assets/images/affiliates/join.svg';
import Promote from '../../assets/images/affiliates/promote.svg';
import Earn from '../../assets/images/affiliates/earn.svg';
import Timer from '../../assets/images/affiliates/timer.svg';
import Card from '../../assets/images/affiliates/card.svg';
import Url from '../../assets/images/affiliates/url.svg';
import Panel from '../../assets/images/affiliates/panel.svg';
import Hexigon from '../../assets/images/affiliate.svg';

const Affiliates = () => {
    return (
        <main>
            <AdvancedHero subtitle="Earn Money with our" title="Affiliate Program" description="Spread the word about our services and earn money for each sale that you bring!" />
            <section className="steps max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5 py-28">
                <div className="primary-gradient px-5 rounded-md pt-12 pb-24">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16 px-4 place-content-evenly">
                        <div>
                            <img src={Join} alt="Join" className='block mx-auto mb-5' />
                            <h1 className='text-center text-gray-100 font-semibold text-xl mb-4'>Join</h1>
                            <p className='text-center text-gray-300'>Sign up for an affiliate account<br /> and get a unique link for sharing.</p>
                        </div>
                        <div>
                            <img src={Promote} alt="Promote" className='block mx-auto mb-5' />
                            <h1 className='text-center text-gray-100 font-semibold text-xl mb-4'>Promote</h1>
                            <p className='text-center text-gray-300'>Share your unique affiliate link<br /> with friends, family, and viewers.</p>
                        </div>
                        <div>
                            <img src={Earn} alt="Earn" className='block mx-auto mb-5' />
                            <h1 className='text-center text-gray-100 font-semibold text-xl mb-4'>Earn</h1>
                            <p className='text-center text-gray-300'>For every share that you bring<br /> with your unique link, earn 20%!</p>
                        </div>
                    </div>
                </div>
                <div className="view-more flex justify-center">
                    <a href="https://client.cyperhost.com/affiliates.php" className="bg-primary hover:bg-secondary px-16 py-4 text-gray-100 hover:text-white rounded-lg transition" Style="margin-top: -30px;">Join Today</a>
                </div>
            </section>
            <section className='benefits py-28 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5'>
                <div className="header mb-24">
                    <h1 className="text-gray-100 text-center text-3xl font-semibold mb-4">Program Benefits</h1>
                    <p className="text-gray-300 text-center">We make it very easy for you to get started as an affiliate of our services.</p>
                </div>
                <div className='body'>
                    <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-x-5 gap-y-10'>
                        <div>
                            <img src={Timer} alt="Timer" className='block mx-auto mb-5' />
                            <h1 className='text-center text-gray-100 text-lg font-semibold'>7 Days Payout Guarantee</h1>
                        </div>
                        <div>
                            <img src={Card} alt="Card" className='block mx-auto mb-5' />
                            <h1 className='text-center text-gray-100 text-lg font-semibold'>No Cap on Earnings</h1>
                        </div>
                        <div>
                            <img src={Url} alt="URL" className='block mx-auto mb-5' />
                            <h1 className='text-center text-gray-100 text-lg font-semibold'>Unique URL with Tracking</h1>
                        </div>
                        <div>
                            <img src={Panel} alt="Panel" className='block mx-auto mb-5' />
                            <h1 className='text-center text-gray-100 text-lg font-semibold'>Affiliate Panel</h1>
                        </div>
                    </div>
                </div>
            </section>
            <section className='more-info py-28'>
                <div className='content bg-primary py-20'>
                    <div className='grid grid-cols-1 lg:grid-cols-2 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5 py-16'>
                        <div>
                            <h1 className='text-gray-100 text-3xl font-semibold mb-7 text-center lg:text-left'>Program Benefits</h1>
                            <p className='text-gray-300 text-xl text-center lg:text-left'>Starting to earn money with Cyperhost is really easy with these terms.</p>
                        </div>
                    </div>
                </div>
                <div className='hidden lg:block max-w-7xl mx-auto px-5 sm:px-5 lg:px-5'>
                    <img src={Hexigon} alt="Hexigon" className='ml-auto' Style='margin-top: -520px;' />
                </div>
            </section>
            <section className='get-started pt-28 pb-36 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5'>
                <div className='bg-primaryDark rounded-xl pt-10 pb-12 px-5'>
                    <div className='header mb-16'>
                        <h2 className='text-center text-gray-300 text-lg font-semibold mb-8'>Ready to get started?</h2>
                        <h1 className='text-center text-gray-100 text-3xl font-semibold mb-4'>Start Earning Today</h1>
                        <p className='text-center text-gray-300'>Receive a $10 sign-up bonus right away and get started!</p>
                    </div>
                    <div className='body'>
                        <div className='flex flex-wrap justify-center items-center'>
                            <div className='mr-0 md:mr-7'>
                                <a href="https://client.cyperhost.com/affiliates.php" className="bg-gray-100 w-full sm:w-full md:w-auto border border-gray-100 px-7 py-3 text-gray-900 font-semibold rounded-md text-base">Sign up Now</a>
                            </div>
                            <div className='mt-10 sm:mt-10 md:mt-0'>
                                <a href="https://client.cyperhost.com/affiliates.php" className="bg-primary w-full sm:w-full md:w-auto border border-primary px-7 py-3 text-gray-300 font-semibold rounded-md text-base">Affiliate Login</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </main> 
    )
}

export default Affiliates